<template>
  <div class="events" :class="{ 'large-width': hasLargeWidth, 'no-width': hasNoWidth }" @scroll="spread">

    <!-- <div v-for="(itemDebug, index) in eventsData" :key="'debug-' + index">
      {{ itemDebug.slug }} <a :href="itemDebug.mp3">mp3</a>  <a :href="itemDebug.url">url</a>
    </div> -->
    <screen v-for="(item, index) in screensData" :key="index" :id="item.slug" :screenItem="item"/>
  </div>
</template>

<script>
import Screen from './Screen'

export default {
  name: 'Screens',
  data () {
    return {
      scrollTop: 0
    }
  },
  computed: {
    currentScreen () {
      return this.screensData.find(event => event.slug === this.$store.state.eventId)
    },
    hasLargeWidth () {
      return this.currentScreen && (this.currentScreen.itemType === 'intro' || this.currentScreen.itemType === 'landing')
    },
    hasNoWidth () {
      return this.$route.path === '/explore-the-land'
    },
    screensData () {
      return this.$store.getters.screensData
    }
  },
  components: {
    Screen
  },
  mounted () {
    const anchor = this.$router.currentRoute.hash
    this.$nextTick().then(() => {
      if (anchor) {
        const element = document.getElementById(anchor.replace('#', ''))
        var top = element.offsetTop
        this.$el.scrollTo(element, top)
      }
    })
  },
  methods: {
    spread (e) {
      // this.scrollTop = this.$el.scrollTop
      this.$store.commit('setPagePosition', this.$el.scrollTop)
    }
  }
}
</script>

<style lang="scss">
  .events::-webkit-scrollbar {
    display: none;
  }

.events {
  width: 400px;
  border: none;
  overflow-y: scroll;
  overflow-x: hidden;
  overflow: -moz-scrollbars-none;
  scrollbar-width: none;
  scroll-behavior: smooth;
  scroll-snap-type: y mandatory;
  margin: 0 120px;
  @media only screen and (max-width: 768px) {
      // scroll-behavior: initial;
      margin: 0 64px;
      width: 100%;
  }

  section {
    height: 100%;
    // border: solid 1px;
    // margin-top: -240px;
    display: flex;
    align-items: center;
    scroll-snap-align: start end;
  }
}
.events.large-width {
  width: 100vw;
  margin: 0;
}
.events.no-width {
  width: 0;
  margin: 0;
}
</style>
